import type { ChangeEvent } from 'react';

import { SelectField } from '../../SelectField';
import type { AutoshipFrequencyItem } from '../lib';

type AutoshipFrequencySelectProps = Readonly<{
    items: AutoshipFrequencyItem[];
    value: string;
    onChange: (value: string) => void;
    testId?: string;
}>;

export const AutoshipFrequencySelect = ({
    items,
    value,
    onChange,
    testId = 'select-frequency',
}: AutoshipFrequencySelectProps) => (
    <SelectField
        label="Ships every"
        items={items}
        onChange={(event: ChangeEvent<HTMLSelectElement>) => onChange(event.target.value)}
        data-testid={testId}
        value={value}
    />
);
